<template>
  <div class="my-pooq-content-body">
    <portal to="delete-edit-header" v-if="downloadList.length > 0">
      <my-pooq-history-header :change-mode="changeMode" :checked-count="checkedCount" :delete-all="deleteAll"
                              :delete-selected="deleteSelected" :is-delete-mode="isDeleteMode" :total-count="totalCount"
                              :download-count="downloadCount" :download-available-count="downloadAvailableCount"
      />
    </portal>
    <div class="mypooq-list"
         v-infinite-scroll="loadMore"
         :infinite-scroll-distance="200"
         :infinite-scroll-throttle-delay="200">
        <my-pooq-empty-list v-if="showEmptyList" info-text="다운로드 내역이 없어요."></my-pooq-empty-list>
      <div v-else-if="!showEmptyList">
        <ul class="seen-list">
          <li v-for="(downloadItem, index) in downloadList" :key="downloadItem.contentid + index" :class="downloadItem.expired ? 'expire' : ''">
          <span class="list-select" v-if="isDeleteMode" @click.prevent="()=>toggleDownloadCheck(downloadItem)">
            <input type="checkbox" :id="'select-btn_' + index" class="select-btn" v-model="downloadItem.check">
              <label :for="'select-btn_' + index">
                <span class="a11y-hidden">내역 체크박스</span>
                <CheckOn v-if="downloadItem.check"/>
                <CheckOff v-if="!downloadItem.check"/>
              </label>
            </span>
            <span class="download-wrap">
            <span class="download-info">
              <span class="badge-group">
                <span class="badge ui">{{downloadItem.contenttype.toUpperCase() ==='MOVIE' ? '영화' : downloadItem.contenttype.toUpperCase()}}</span>
              </span>
                <span class="download-title">{{downloadItem.episodenumber ? downloadItem.episodenumber+'회': ''}} {{downloadItem.programtitle}}</span>
                <span class="release-date">
                  <span>이용일</span>
                  <i class="icon-dotted"></i>
                  <span>{{downloadItem.downloaddatetime}}</span>
                </span>
                <span class="end-date">
                  <span>만료일</span>
                  <i class="icon-dotted"></i>
                  <span>{{downloadItem.enddatetime}}</span>
                </span>
              </span>
                <span class="download-count-link">
                  <span class="download-count">
                    <strong>{{downloadItem.downloadcount.split('/')[0]}}</strong>
                     / {{downloadItem.downloadcount.split('/')[1]}}
                    </span>
                  <span class="download-text">다운로드</span>
                </span>
              </span>
          </li>

        </ul>
      </div>
    </div>

  </div>
</template>

<script>
import { MyPooqService } from '@/common/api/api.service'
import { infiniteScroll, progressBar } from '@/common/directives'
import MyPooqEmptyList from '@/components/lnb/mypooq/MyPooqEmptyList'
import CheckOn from '@/assets/svg/common/ic-check-on.svg'
import CheckOff from '@/assets/svg/common/ic-check-off.svg'
import { get } from 'lodash'
import MyPooqHistoryHeader from '@/components/lnb/mypooq/MyPooqHistoryHeader'
import { MAX_SELECT_COUNT, SET_EDITOR_VIEW_CLASS } from '@/common/constant'
import utils from '@/common/util/utils'
import { PATH_NAME_PLAYER } from '@/common/router.const'
import { EventBus } from '@/components/eventbus/EventBus'

export default {
  name: 'MyPooqUseListHistoryDownload',
  components: {
    MyPooqHistoryHeader,
    MyPooqEmptyList,
    CheckOn,
    CheckOff
  },
  directives: {
    infiniteScroll,
    progressBar
  },
  data () {
    return {
      offset: 0,
      limit: 20,
      isDeleteMode: false,
      showEmptyList: false,
      endOfList: false,
      isLoading: false,
      downloadList: [],
      totalCount: 0,
      downloadCount: 0,
      downloadAvailableCount: 0
    }
  },
  computed: {
    checkedCount () {
      return this.downloadList.filter(download => download.check).length
    }
  },
  methods: {
    toggleDownloadCheck (downloadItem) {
      if (this.checkedCount >= MAX_SELECT_COUNT) {
        if (get(downloadItem, 'check', false)) {
          downloadItem.check = !downloadItem.check
        }
        if (this.checkedCount >= MAX_SELECT_COUNT) {
          utils.alert(`최대 ${MAX_SELECT_COUNT}개 까지만 선택할 수 있습니다.`)
        }
      } else {
        downloadItem.check = !downloadItem.check
      }
    },
    goPlayer (downloadItem) {
      this.$router.push({
        name: PATH_NAME_PLAYER,
        params: {
          section: 'vod'
        },
        query: { contentid: downloadItem.contentid, referer: this.$route.fullPath }
      })
    },
    deleteSelected () {
      const checkedList = this.downloadList.filter((item) => {
        return item.check
      }).map((item) => {
        return item.contentid
      })
      if (checkedList.length > 0) {
        MyPooqService.deleteDownloadHistory({ id: checkedList }).then(({ data }) => {
          this.downloadList = []
          this.offset = 0
          this.totalCount = 0
          this.$nextTick(() => {
            this.setData()
          })
        })
      }
    },
    deleteAll () {
      MyPooqService.deleteDownloadHistoryAll({ contenttype: 'all' }).then(({ data }) => {
        this.downloadList = []
        this.offset = 0
        this.totalCount = 0
        this.$nextTick(() => {
          this.setData()
        })
      })
    },
    changeMode () {
      if (this.isDeleteMode) { // off 시킬때
        this.downloadList = this.downloadList.map((download) => {
          download.check = false
          return download
        })
      }
      this.isDeleteMode = !this.isDeleteMode
    },
    loadMore () {
      if (this.endOfList) return
      this.setData()
    },
    setData () {
      if (this.isLoading) return
      this.isLoading = true
      MyPooqService.downloadHistory({
        limit: this.limit,
        offset: this.offset,
        orderby: 'new'
      }).then(({ data }) => {
        const resList = get(data, 'list', []).map((item) => {
          const [downloadCount, totalCount] = get(item, 'downloadcount', '0/0').split('/')
          item.expired = Number(downloadCount) >= Number(totalCount)
          item.check = false
          return item
        })
        if (this.totalCount === 0) {
          this.totalCount = Number(get(data, 'pagecount', 0))
        }
        this.endOfList = resList.length === 0
        this.showEmptyList = this.downloadList.length === 0 && resList.length === 0
        if (this.offset === 0) {
          this.downloadCount = Number(get(data, 'totalcount.downloadcontentcount', 0))
          this.downloadAvailableCount = Number(get(data, 'totalcount.downloadavailablecount', 0))
        }
        this.offset += this.limit
        this.downloadList = this.downloadList.concat(resList)
        EventBus.$emit(SET_EDITOR_VIEW_CLASS, this.downloadList.length !== 0)
        this.isLoading = false
      })
    },
    moveUrl () {
      utils.common.checkInstallApps('mypooq/use_download')
    }
  }
}
</script>
<style scoped>
  .select-btn {
    display: none !important;
  }
</style>
